import {ALB_API_BASE_URL, AWS_LAMBDA_ENDPOINT} from "./constants";
import { v4 as uuidv4 } from "uuid";
import defaultSheet from "./defaultSheet.json";
import JSZip from 'jszip';
import { authFetch } from "./authFetch";
import { uploadDriverInChunks } from "./chunkUpload";

// export const traverseItems = async (items) => {
//   const files = [];
//   const traverseEntry = async (entry, path = '') => {
//     if (entry.isFile) {
//       await new Promise(resolve => {
//         entry.file(file => {
//           files.push({ file, relativePath: path + file.name });
//           resolve();
//         });
//       });
//     } else if (entry.isDirectory) {
//       const reader = entry.createReader();
//       let readEntries;
//       do {
//         readEntries = await new Promise(r => reader.readEntries(r));
//         for (const e of readEntries) {
//           await traverseEntry(e, `${path}${entry.name}/`);
//         }
//       } while (readEntries.length);
//     }
//   };

//   for (const item of items) {
//     const entry = item.webkitGetAsEntry && item.webkitGetAsEntry();
//     if (entry) await traverseEntry(entry);
//   }

//   return files;
// };

// export const extractMidiFromZip = async (zipFile) => {
//   const zip = await JSZip.loadAsync(zipFile);
//   const midiFiles = [];

//   for (const [path, zipEntry] of Object.entries(zip.files)) {
//     if (!zipEntry.dir && /^(?!(\.|_)).*\.mid(i)?$/i.test(path)) {
//       const blob = await zipEntry.async('blob');
//       const filename = zipEntry.name.split('/').pop();
//       midiFiles.push({ file: new File([blob], filename), relativePath: path });
//     }
//   }

//   return midiFiles;
// };

const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result.split(',')[1]);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

export async function createSheetBatch({ userId, midiFiles, folder }) {
  const sheets = midiFiles.map(({ file, relativePath }) => {
    const sheetId = uuidv4();
    const clone = JSON.parse(JSON.stringify(defaultSheet));
    const filePath = folder ? `${folder}/${relativePath}` : relativePath;
    clone.data.general_info.original_filename = file.name;
    clone.data.general_info.displayed_filename = file.name.replace(/\.[^/.]+$/, '');
    clone.data.general_info.file_path = filePath;
    return { sheet_id: sheetId, default_sheet: clone, file };
  });

  const res = await authFetch(`${AWS_LAMBDA_ENDPOINT}/batchCreateAnnotationSheets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, sheets: sheets.map(s => ({ sheet_id: s.sheet_id, default_sheet: s.default_sheet })) })
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Batch creation failed (${res.status}): ${txt}`);
  }
  console.log(`✅ Created ${sheets.length} sheets`);

  return sheets; 
}


export async function uploadDriver({ sheets, onLoadingChange }) {
  return;
  if (onLoadingChange) onLoadingChange(true);
  try {
    // Prepare JSONL payload: each object contains sheet_id + base64 data
    const jsonl = await Promise.all(
      sheets.map(async ({ sheet_id, original_data, original_path }) => {
        const data = await readFileAsBase64(original_data);
        return { sheet_id, original_data: data, processed_data: data, original_path: original_path };
      })
    );

    console.log('Uploading driver with sheets:', jsonl);

    const res = await authFetch(`${ALB_API_BASE_URL}/uploadDriver`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ jsonl })
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`UploadDriver failed (${res.status}): ${txt}`);
    }

    let result = await res.json();
    console.log('Driver response:', result);
    return result;
  } finally {
    if (onLoadingChange) onLoadingChange(false);
  }
}

export async function deleteSheetBatch(sheets) {
  const res = await authFetch(`${AWS_LAMBDA_ENDPOINT}/batchDeleteAnnotationSheet`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sheetIds: sheets.map(s => s.sheet_id) })
  });
  if (!res.ok) {
    const txt = await res.text();
    console.warn(`Upload delete failed (${res.status}): ${txt}`);
  }
}

export async function uploadMidiWithDriver({ midiFiles, userId, folder, onLoadingChange }) {
  try {
    // Filter out hidden files that are likely system files starting with "."
    const visibleMidiFiles = midiFiles.filter(({ relativePath }) => {
      const base = relativePath.split("/").pop(); // just the filename
      return base && !base.startsWith(".");
    });

    const sheets = visibleMidiFiles.map(({ file, relativePath }) => {
      const filePath = folder ? `${folder}/${relativePath}` : relativePath;
      console.log("uploading driver with file path: ", filePath)
      return { original_path: filePath, original_data: file, user_id: userId };
    });
    const result = await uploadDriverInChunks({
      sheets,         // same array you passed before
      onLoadingChange
    })
    console.log("Upload completed with uploadDriver stats: ", result);
    if (result.failed.length > 0) {
      console.log("Deleting failed uploads for", result.failed);
      deleteSheetBatch(result.failed);
    }
    return result;
  } catch (e) {
    console.error('Driver upload error:', e);
    throw e;
  }
}
